export const DatafordelerUsername = 'MRELCFWBOX'
export const DatafordelerPassword = '!6ydEFIH-2VT.7!Ukvc!'
